import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Flag } from '../../api';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import {
  setMaintenanceModeEnabled,
  setVisibilityOfCustomerChat,
  setYouthHealthPackagesEnabled,
  setVisibilityOfAdvancedMedicSearch,
  setJevUnapprovedPremiumHintEnabled,
} from '../../states/app/app.actions';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class FeatureService {
  public static readonly baseUrl = 'api/public';

  constructor(
    private http: HttpClient,
    private store: Store,
  ) {}

  public loadFeatureFlags(): void {
    this.http
      .get<Flag>(`${FeatureService.baseUrl}/features/customerChatEnabled`)
      .pipe(
        untilDestroyed(this),
        map((flag) => {
          this.store.dispatch(setVisibilityOfCustomerChat({ showCustomerChat: flag.enabled }));
        }),
      )
      .subscribe();
    this.http
      .get<Flag>(`${FeatureService.baseUrl}/features/maintenanceModeEnabled`)
      .pipe(
        untilDestroyed(this),
        map((flag) => {
          this.store.dispatch(setMaintenanceModeEnabled({ showMaintenanceModeScreen: flag.enabled }));
        }),
      )
      .subscribe();
    this.http
      .get<Flag>(`${FeatureService.baseUrl}/features/youthHealthPackagesEnabled`)
      .pipe(
        untilDestroyed(this),
        map((flag) => {
          this.store.dispatch(setYouthHealthPackagesEnabled({ showYouthHealthPackages: flag.enabled }));
        }),
      )
      .subscribe();
    this.http
      .get<Flag>(`${FeatureService.baseUrl}/features/advancedMedicSearch`)
      .pipe(
        untilDestroyed(this),
        map((flag) => {
          this.store.dispatch(setVisibilityOfAdvancedMedicSearch({ showAdvancedMedicSearch: flag.enabled }));
        }),
      )
      .subscribe();
    this.http
      .get<Flag>(`${FeatureService.baseUrl}/features/jevUnapprovedPremiumHintEnabled`)
      .pipe(
        untilDestroyed(this),
        map((flag) => {
          this.store.dispatch(setJevUnapprovedPremiumHintEnabled({ showJevUnapprovedPremiumHint: flag.enabled }));
        }),
      )
      .subscribe();
  }
}
